module.exports = __webpack_public_path__ + "img/Logo_EMLV_fd_couleur.398cb1e7.png";